import React from "react";

const CheckoutDeliveryAddressInfo = (props) => {

    return (<div className="row checkout__container">
        <div className="small-12 simple-table">
            <div className="checkout__deliveryaddressinfo" dangerouslySetInnerHTML={{__html: props.deliveryAddressInfoMessage}}></div>
        </div>
    </div>)

}

export default CheckoutDeliveryAddressInfo;